import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_up",
  "use": "icon-i_up-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_up\"><title>icon_画板</title><path d=\"M8.3,20.81A1.09,1.09,0,0,1,8.62,20l7.6-7.6a1.13,1.13,0,0,1,1.58,0L25.39,20a1.11,1.11,0,0,1-1.57,1.57L17,14.78,10.2,21.59a1.11,1.11,0,0,1-1.58,0A1.07,1.07,0,0,1,8.3,20.81Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol